<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :class="className">
    <path d="M3 17l6-6 4 4 8-8" />
    <path d="M14 7h7v7" />
  </svg>
</template>

<script>
export default {
  name: 'IconTrendingUp',
  props: { className: { type: String, default: 'w-4 h-4' } },
}
</script>

